// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.css';

// safer base href lookup
const baseEl = document.querySelector('base');
const baseUrl = (baseEl && baseEl.getAttribute('href')) || '/';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <BrowserRouter basename={baseUrl}>
        <App />
    </BrowserRouter>
);

// Unregister any old service workers and reload once (to bust caches)
unregisterServiceWorker();
if ('serviceWorker' in navigator) {
    const RELOADED_FLAG = 'sw-unreg-reloaded';
    navigator.serviceWorker.getRegistrations().then((regs) => {
        if (regs.length > 0 && !sessionStorage.getItem(RELOADED_FLAG)) {
            sessionStorage.setItem(RELOADED_FLAG, '1');
            window.location.reload();
        }
    });
}